import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { FormsModule } from '@angular/forms';
import { GstSlab, GstSlabsResponse, GstSlabService } from './gst-slab.service';
import { ToastrService } from 'ngx-toastr';
import { RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-gst-slab-view',
  standalone: true,
  templateUrl: './gst-slab-view.component.html',
  styleUrls: ['./gstslabs.component.scss'],
  imports: [FormsModule, RouterLink, CommonModule],
})
export class GstSlabViewComponent implements OnInit {
  gstSlabs: GstSlab[] = [];
  isLoading = true;
  errorMessage: string | null = null;

  currentPage = 1;
  pageCount = 1;
  totalEntries = 0;
  pageSize = 10;

  searchTerm = '';

  constructor(
    private gstSlabService: GstSlabService,
    private router: Router,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.loadGstSlabs();
  }

  loadGstSlabs(page: number = this.currentPage): void {
    this.isLoading = true;
    this.currentPage = page;

    this.gstSlabService
      .getAllGstSlabs(page, this.pageSize, this.searchTerm)
      .subscribe({
        next: (res: GstSlabsResponse) => {
          this.gstSlabs = res.data || [];
          this.totalEntries = res.total || 0;
          this.pageCount =
            res.totalPages || Math.ceil(res.total / res.limit) || 1;
          this.pageSize = res.limit || 10;
          this.isLoading = false;
          this.errorMessage = null;
        },
        error: () => {
          this.errorMessage = 'Failed to fetch GST slabs.';
          this.isLoading = false;
          this.toastr.error(
            'Failed to fetch GST slabs. Please try again.',
            'Error'
          );
        },
      });
  }

  onSearch(): void {
    this.loadGstSlabs(1);
  }

  pageSizeChange(): void {
    this.loadGstSlabs(1);
  }

  editSlab(id?: string) {
    if (id) {
      this.router.navigate(['/gst-slab/edit', id]);
    } else {
      this.router.navigate(['/gst-slab/create']);
    }
  }

  deactivateSlab(id: string): void {
    if (confirm('Are you sure you want to deactivate this GST slab?')) {
      this.gstSlabService.deleteGstSlab(id).subscribe({
        next: () => {
          this.toastr.success('GST Slab deactivated successfully.', 'Success');
          this.loadGstSlabs(this.currentPage);
        },
        error: () => {
          this.errorMessage = 'Deactivation failed.';
          this.toastr.error('Deactivation failed. Please try again.', 'Error');
        },
      });
    }
  }

  goToPage(page: number): void {
    if (page < 1 || page > this.pageCount || page === this.currentPage) return;
    this.currentPage = page;
    this.loadGstSlabs();
  }

  getVisiblePages(): number[] {
    const pages: number[] = [];
    const start = Math.max(2, this.currentPage - 2);
    const end = Math.min(this.pageCount - 1, this.currentPage + 2);

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    return pages;
  }
}
